// extracted by mini-css-extract-plugin
export var children = "Image-module--children--z2MfU";
export var framed = "Image-module--framed--jgunx";
export var image = "Image-module--image--dM-HF";
export var imageNarrowViewport = "Image-module--imageNarrowViewport--wZ6Xb";
export var inlay = "Image-module--inlay--HbtYx";
export var root = "Image-module--root--1TbvL";
export var withInlay = "Image-module--withInlay--F6WwK";
export var withInlayFromLeft = "Image-module--withInlayFromLeft--O2Wmm";
export var withInlayFromRight = "Image-module--withInlayFromRight--FEonc";